import useSWR from 'swr'

export default function useCustomerKitsSearch(params = {}) {
  const query = new URLSearchParams(params).toString()
  const { data, error } = useSWR(`/api/account/kits/find?${query}`)

  return {
    kits: data?.kits || undefined,
    isLoading: !error && !data,
    isError: error,
  }
}
